import { getConfig } from '@superbet-group/web.lib.config';

export function getPrintUrls(offerNames: { [key: string]: string }): Record<string, string> {
    const baseUrl = getConfig().printPdfUrls?.host || '';
    const nowTimestamp = new Date().getTime();
    return Object.entries(offerNames)
        .reduce((acc, [key, value]) => {
            acc[key] = getPrintUrl(value, baseUrl, nowTimestamp);
            return acc;
        }, {} as Record<string, string>);
}

function getPrintUrl(name: string, baseUrl: string, nowTimestamp: number): string {
    return `${baseUrl}${name}${nowTimestamp}`;
}
